import styled, { keyframes, css } from 'styled-components';

export interface IModalProps {
    animationDuration?: number;
    isClosing?: boolean;
}

const OPACITY = 0.5;
const modalEntryAnimation = keyframes`
    from {
        opacity: 0;
    }

    to {
        opacity: ${OPACITY};
    }
`;

const modalExitAnimation = keyframes`
    from {
        opacity: ${OPACITY};
    }

    to {
        opacity: 0;
    }
`;

export const Modal = styled.div.attrs((props: IModalProps) => ({
    className: String('ap-modal'),
    ...props
}))`
    background-color: ${({ theme: { modal } }) => modal.colors.backgroundColor};
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    position: absolute;
    ${({ animationDuration = 100, isClosing }) =>
    css`animation: ${animationDuration}ms ${isClosing ? modalExitAnimation : modalEntryAnimation} ease-in`};
`;
